var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GetUnlockedGroundGraphicIso as BF2GetUnlockedGroundGraphicIso } from "../../../graphics/GetUnlockedGroundGraphicIso";
import { selectExpansionInfo } from "../../../selectors/selectExpansionInfo";
import { utilGrid } from "../../../utils/grid/utilGrid";
import { SceneLayer } from "../../scenes/SceneLayer";
var LayerPlayerBaseUnlockedGround = /** @class */ (function (_super) {
    __extends(LayerPlayerBaseUnlockedGround, _super);
    function LayerPlayerBaseUnlockedGround() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.unlockedGroundById = new Map();
        _this.shouldUpdate = function (state, previousState) { return !!state.expansionInfo.unlockedExpansionIds; };
        _this.update = function (props) {
            var expansionInfo = props.expansionInfo, getUnlockedGroundGraphicIso = props.getUnlockedGroundGraphicIso;
            var expansionIds = expansionInfo.unlockedExpansionIds;
            // Remove locked ones
            _this.children
                .filter(function (child) { return expansionIds.indexOf(parseInt(child.name, 10)) === -1; })
                .forEach(function (child) { return _this.cleanupExpansion(child); });
            // Add unlocked ones
            expansionIds.forEach(function (expansionId) {
                return _this.drawUnlockedGround(expansionId, expansionInfo.baseSetup, getUnlockedGroundGraphicIso);
            });
        };
        _this.mapState = function (state) { return ({
            expansionInfo: selectExpansionInfo(state),
            getUnlockedGroundGraphicIso: BF2GetUnlockedGroundGraphicIso,
        }); };
        _this.cleanupExpansion = function (child) {
            _this.cleanupChild(child);
            _this.unlockedGroundById.delete(parseInt(child.name, 10));
        };
        _this.drawUnlockedGround = function (expansionId, baseSetup, getUnlockedGroundGraphicIso) {
            if (_this.unlockedGroundById.has(expansionId)) {
                return;
            }
            var _a = utilGrid.expansionIdToXY(expansionId, baseSetup), x = _a.x, y = _a.y;
            var expansionsSizeX = baseSetup.expansionsSizeX, expansionsSizeY = baseSetup.expansionsSizeY;
            var display = getUnlockedGroundGraphicIso({
                id: -1,
                x: 0,
                xExtent: expansionsSizeX,
                y: 0,
                yExtent: expansionsSizeY,
            });
            if (display != undefined) {
                var pos = utilGrid.mapToScreen(x, y);
                display.position.set(pos.x, pos.y);
                display.name = "" + expansionId;
                _this.addChild(display);
                _this.unlockedGroundById.set(expansionId, display);
            }
        };
        return _this;
    }
    return LayerPlayerBaseUnlockedGround;
}(SceneLayer));
export { LayerPlayerBaseUnlockedGround };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerPlayerBaseUnlockedGround.ts
// module id = 2222
// module chunks = 3